// extracted by mini-css-extract-plugin
export default {"title":"PickUpCard_title__4RQ1R","value":"PickUpCard_value__klGVo"};